import * as React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import * as moment from 'moment';
import * as classNames from 'classnames';
import { IPricingRequest } from 'common/interfaces/pricing';

// Styles
const s = require('./PricingRequestListItem.css');
const arrowIcon = require('assets/grey arrow.svg');
const blueArrowIcon = require('assets/blue arrow.svg');

// Props
interface IPricingRequestListItemProps {
    className?: string;
    showLeadAndAuthorName?: boolean;
    onClick: (request: IPricingRequest) => void;
    request: IPricingRequest;
}

// Component
@observer
export class PricingRequestListItem extends React.Component<IPricingRequestListItemProps, {}> {
    static get defaultProps(): IPricingRequestListItemProps {
        return {
            className: null,
            showLeadAndAuthorName: true,
            onClick: null,
            request: null,
        };
    }

    constructor(props) {
        super(props);
    }

    @computed private get leadDba(): string {
        const { request } = this.props;

        return (typeof request.provider.dba !== 'undefined' && request.provider.dba)
            ? request.provider.dba : '';
    }

    @computed private get leadLegalBusName(): string {
        const { request } = this.props;

        return (typeof request.provider.legalBusName !== 'undefined' && request.provider.legalBusName)
            ? request.provider.legalBusName : '';
    }

    @computed private get authorName(): string {
        const { request } = this.props;

        return typeof request.createdByUser !== 'undefined' && typeof request.createdByUser.name !== 'undefined'
        ? request.createdByUser.name
        : typeof request.createdByUserId !== 'undefined'
                ? request.createdByUserId.toString()
                : '';
    }

    @computed private get createdAtDate(): string {
        const { request } = this.props;

        return typeof request.createdAt !== 'undefined' && request.createdAt
            ? moment(request.createdAt).format('MMM Do, YYYY h:mm A')
            : '';
    }

    public render() {
        const { request } = this.props;

        return (
            <div className={classNames(s.request, this.props.className)} onClick={this.handlePricingRequestClick}>
                {(this.props.showLeadAndAuthorName) && (
                    <div>
                        {this.renderRequestId()}

                        {(typeof request.provider !== 'undefined' && request.provider) && (
                            <h4 className={s.lead}>
                                {(this.leadDba) && (
                                    <strong>{this.leadDba}</strong>
                                )}
                                {(this.leadLegalBusName && this.leadDba !== this.leadLegalBusName) && (
                                    <em>{this.leadLegalBusName}</em>
                                )}
                            </h4>
                        ) || (
                            <h4 className={s.lead}>
                                <strong>{request.providerId}</strong>
                            </h4>
                        )}
                    </div>
                ) || (
                    <div>
                        {this.renderRequestId()}
                    </div>
                )}

                {(typeof request.note !== 'undefined' && request.note) && (
                    <p className={s.note}>{request.note}</p>
                )}

                <p className={s.author}>
                    {(this.createdAtDate) && (
                        <span>{this.createdAtDate}</span>
                    )}

                    {(this.props.showLeadAndAuthorName && this.authorName && this.createdAtDate) && (
                        <img className={s.arrowIcon} src={arrowIcon} />
                    )}

                    {(this.props.showLeadAndAuthorName && this.authorName) && (
                        <span>{this.authorName}</span>
                    )}
                </p>

                <img className={s.arrow} src={blueArrowIcon} />
            </div>
        );
    }

    private renderRequestId() {
        return (
            <h3 className={s.id}>
                <span>Request #</span>
                <strong>{this.props.request.id}</strong>
            </h3>
        );
    }

    private handlePricingRequestClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (this.props.onClick) {
            this.props.onClick(this.props.request);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/pricing/PricingRequestListItem.tsx